import React, { PureComponent } from "react";
import PropTypes from "prop-types";
// Material imports
import withStyles from "@mui/styles/withStyles";
import Typography from "@mui/material/Typography";
//Limitless imports
import { withi18n } from "../../../../customer/components";
class FormMessage extends PureComponent {
  render() {
    const {
      classes,
      errorMessage,
      infoMessage,
      t,
      children,
      containerClass
    } = this.props;
    const message = errorMessage ? errorMessage : infoMessage;
    return /*#__PURE__*/React.createElement(Typography, {
      className: `${errorMessage ? classes.errorMessage : classes.infoMessage} ${containerClass && containerClass}`,
      id: "formMessageText",
      align: "center",
      color: "textPrimary",
      variant: "body1"
    }, `${t(message)} `, children);
  }
}
const styles = theme => ({
  errorMessage: {
    minHeight: 20,
    marginBottom: 10,
    color: theme.palette.error.main,
    alignSelf: "center",
    textAlign: "center"
  },
  infoMessage: {
    minHeight: 20,
    marginBottom: 10,
    alignSelf: "center"
  }
});
export default withStyles(styles)(withi18n(FormMessage));
FormMessage.propTypes = {
  classes: PropTypes.object.isRequired,
  errorMessage: PropTypes.string.isRequired,
  infoMessage: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
  children: PropTypes.node,
  containerClass: PropTypes.string
};